import { useState, useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Component from './Login';
import { steps } from './steps';
import {
  useCheckUserExist,
  useLoginActions,
  useLoginForm,
  useEmailPrefill,
  useWhoAmIRedirect,
  useMfaFlowPersistence,
} from './hooks';
import { readMfaStep, clearMfaFlow } from './mfaFlowStorage';
import authContext from '../../../services/auth/context';

export default function LoginRoute(props) {
  const [t] = useTranslation('login');
  const auth = useContext(authContext);
  const history = useHistory();

  // Reidrata o step do cadastro MFA no F5 (síncrono, para o guard do redirect
  // enxergar o step MFA antes do whoAmI resolver).
  const [currentStep, setCurrentStep] = useState(
    () => readMfaStep(steps) || steps.email,
  );
  const [
    workstationAuthorizationRequired,
    setWorkstationAuthorizationRequired,
  ] = useState(false);

  const resolveWorkstationAuthorizationRequired = useCheckUserExist();

  const navigateToApp = useCallback(
    user => {
      clearMfaFlow();
      props.history.push({
        pathname: 'products',
        state: { ...user, redirectUri: auth.redirectUri },
      });
    },
    [props.history, auth.redirectUri],
  );

  const actions = useLoginActions({
    auth,
    history,
    navigateToApp,
    setCurrentStep,
    workstationAuthorizationRequired,
    setWorkstationAuthorizationRequired,
    resolveWorkstationAuthorizationRequired,
  });

  const formikBag = useLoginForm({ currentStep, actions });

  useEmailPrefill({
    formikBag,
    resolveWorkstationAuthorizationRequired,
    setWorkstationAuthorizationRequired,
    setCurrentStep,
    auth,
  });

  useWhoAmIRedirect({
    currentStep,
    redirectUri: auth.redirectUri,
    history: props.history,
  });

  useMfaFlowPersistence({
    currentStep,
    setCurrentStep,
    formikBag,
    auth,
    steps,
  });

  const openTerms = () =>
    window.open('https://www.portergroup.com.br/termos-de-uso/');

  const openPrivacy = () =>
    window.open('https://www.portergroup.com.br/politica-de-privacidade/');

  return Component({
    ...props,
    t,
    currentStep,
    setCurrentStep,
    formikBag,
    steps,
    openTerms,
    openPrivacy,
    auth,
  });
}
